<template>
    <div>
        <ly-crud ref="lycrud"  v-bind="crudConfig" >
            <template v-slot:customHandle="slotProps">
                <span class="table-operate-btn" @click="handleClick(slotProps.row,'disable')" v-show="hasPermission(this.$route.name,'Disable')">
                    <span v-if="slotProps.row.is_active">禁用</span>
                    <span v-else>启用</span>
                </span>
            </template>
        </ly-crud>
    </div>
</template>

<script lang="jsx">
    import {eqManageChData} from '@/api/api'
    import LyCrud from "@/components/lycrud_eq_changedata";
    import templateData from "@/components/dict/crudTemplateData"
    import { h,resolveComponent } from 'vue';
    export default {
        name: "eqManage",
        components: {LyCrud},
        data(){
            return{
                defaultImg:require('../../assets/img/avatar.jpg'),
                //crud配置
                crudConfig:{
                    //crud请求方法配置
                    crudRequest:{
                        search:eqManageChData,
                    },
                    //搜索栏目配置
                    searchBar:{
                        showSearchBar:true,//显示搜索栏目
                        searchColums:[
                            {label:'数据类型',type:'select',prop:'data_type',width:100,placeholder:'请选择',
                                options:[
                                    {value:1,label:'设置数据'},
                                    {value:2,label:'诊断数据'},
                                    {value:3,label:'服务数据'},
                                    {value:4,label:'后台数据'}
                                ]
                            },
                            {label:'序列号',type:'input',prop:'serial_num',width:200,maxlength:60,placeholder:'请输入序列号'},
                            // {label:'操作时间',type:'datepicker-datetimerange',prop:'dates'},
                        ]
                    },
                    //显示分页
                    showPagination:true,
                    //分页配置
                    pageparams: {
                        limit: 10,//每页显示的条数(默认每页显示10条)//非必填
                        //pageSizes:[10,20,30,40,50,200],//非必填
                        // layout:'total, sizes, prev, pager, next, jumper',//非必填
                    },
                    //crud按钮配置
                    
                    //crud弹窗属性
                    formOptions: {
                        width:'45%',//dialog弹窗宽度：类型：百分比或字符串
                        gutter: 20, // Layout布局栅格间隔
                    },
                    //crud表格属性
                    tableOptions:{
                        border:true,
                        showHeader:true,
                    },
                    showSelectable:false,//表格显示复选项框
                    tableColumns:[
                        {label:'更新时间',prop:'change_time',minWidth:'150',sortable: true,hidden:false },
                         {label:'序列号',prop:'serial_num',minWidth:'110',sortable: false,hidden:false },
                         {label:'修改参数',prop:'name',minWidth:'200',sortable: false,hidden:false,
                         render: (row) =>{
                                    let elTag = this.EtoC(row.name)
                                    return elTag   
                                },},
                        {label:'修改前',prop:'before',minWidth:'100',sortable: false,hidden:false},
                         {label:'修改后',prop:'after',minWidth:'100',sortable: false,hidden:false,},
                         {label:'操作人',prop:'operator',minWidth:'100',sortable: false,hidden:false}]
                    //table表头列
                    
                },

            }
        },
        onshow(){
        },
        methods:{
        EtoC(data) {
        var str = data
        switch (str) {
            case "low_adj_value":
                return "低位调整值";
            case "low_adj_percent":
                return "低位百分比";
            case "high_adj_value":
                return "高位调整值";
            case "high_adj_percent":
                return "高位百分比";
            case "medium":
                return "物料性质";
            case "water_fast_change":
                return "水位快速变化";
            case "water_first_echo":
                return "选择首波";
            case "sur_wave":
                return "表面波动";
            case "foam":
                return "泡沫";
            case "DKsmall_water":
                return "DK值小";
            case "wave_guide":
                return "导波管测量";
            case "material_fast_change":
                return "物位快速变化";
            case "material_first_echo":
                return "选择首波";
            case "sa_big":
                return "堆角大";
            case "dust":
                return "粉尘强";
            case "DKsmall_low_k":
                return "DK值小低介电常数";
            case "empty_span":
                return "空罐空高";
            case "real_material_high":
                return "真实料高";
            case "DK_value":
                return "DK值";
            case "damp_value":
                return "阻尼时间";
            case "range":
                return "量程设定";
            case "near_blank":
                return "盲区";
            case "sensor_tag":
                return "传感器标签";
            case "wave_guide_dia":
                return "管道直径";
            case "RangeLimit":
                return "量程限制";
            case "SpeedMode":
                return "速度模式";
            case "hydrology":
                return "水文类型";
            case "riverBed_MountingHeight":
                return "开放河床-安装高度";
            case "riverBed_OffshoreDistance":
                return "开放河床-离岸距离";
            case "trapezoidalDitch_MountingHeight":
                return "梯形沟渠-安装高度";
            case "trapezoidalDitch_DitchesWidth":
                return "梯形沟渠-沟渠宽度";
            case "trapezoidalDitch_DitchDepth":
                return "梯形沟渠-沟渠深度";
            case "seasonalRivers_MountingHeight":
                return "季节性河道-安装高度";
            case "seasonalRivers_OffshoreDistance":
                return "季节性河道-离岸距离";
            case "seasonalRivers_RiverBedDepth":
                return "季节性河道-河床深度";
            case "seasonalRivers_WeedHeight":
                return "季节性河道-杂草高度";
            case "surfaceState":
                return "水面状态";
            case "min_distance":
                return "最小空位高度值";
            case "max_distance":
                return "最大空位高度值";
            case "sensor_status":
                return "传感器状态";
            case "simulate_value":
                return "诊断-输出电流";
            case "ouput_mode":
                return "输出电流模式";
            case "fail_mode":
                return "故障模式";
            case "min_current":
                return "最小电流";
            case "reset":
                return "复位";
            case "unit":
                return "单位";
            case "language":
                return "菜单语言";
            case "hart_485_model":
                return "仪表地址";
            case "RTU_DEV":
                return "RTU-DEV";
            case "password_index":
                return "密码启用";
            case "password_num":
                return "密码";
            case "dist_adj":
                return "距离偏量";
            case "echothreshold":
                return "回波(评估)阈值";
            case "envelope_value":
                return "包络线幅度";
            case "auto_gain":
                return "自动增益";
            case "relay_status":
                return "继电器开关";
            case "LowPerThr":
                return "低位闭合阈值";
            case "HighPerThr":
                return "高位闭合阈值";
            case "action_elay":
                return "继电器报警延时";
            case "display_index":
                return "显示内容";
            case "lcd_BKLIGHT":
                return "LCD背光";
            case "FalseEchoDist":
                return "虚假回波距离值";
            case "FilterUplift":
                return "滤波曲线抬升";
            case "addWindowIndex":
                return "滤波器";
            case "increaseRate":
                return "填充速度";
            case "dncreaseRate":
                return "排空速度";
            case "echo_Intensity_Level":
                return "回波强度等级";
            case "guideModeIndex":
                return "引导模式";
            case "reliability":
                return "可靠性";
            case "PQCType":
                return "PQC模式";
            case "TempCompCtrl":
                return "温度补偿开关";
            case "Temp":
                return "温度标定";
            case "TGC":
                return "TGC";
            case "RelaySet":
                return "继电器设置";
            case "RebootTimes":
                return "重启次数";
            case "PrecisionCal":
                return "精度标定";
            case "SmoothWidth":
                return "锯齿波平滑宽度";
            case "FillExceptionTimes":
                return "填充异常次数";
            case "EmptyExceptionTimes":
                return "排空异常次数";
            case "EchoDamping":
                return "波形阻尼";
            case "WindowTrack":
                return "窗口跟踪";
            case "WindowWidth":
                return "窗口宽度";
            case "WindowStart":
                return "窗口起点";
            case "TrackTime":
                return "跟踪时间";
            case "ShowEnhance":
                return "显示增强";
            case "Cal_K":
                return "线性K值";
            case "Cal_B":
                return "线性B值";
            case "fADC":
                return "ADC值";
            case "Tx_Gain":
                return "发增益";
            case "Rx_Gain":
                return "收增益";
            case "ChannelSelect":
                return "频道选择";
            case "nRamp":
                return "RAMP值";
            case "CurrentEnable":
                return "4-20mA电流使能";
            case "ADC_Switch":
                return "ADC开关";
            case "curve_log_multi":
                return "对数曲线倍数";
            case "curve_log_base":
                return "对数曲线基数";
            case "narrow_flt_width":
                return "窄波过滤宽度";
            case "first_sp":
                return "一阶平滑参数";
            case "second_sp":
                return "二阶平滑参数";
            case "third_sp":
                return "三阶平滑参数";
            case "_4mACal":
                return "4mA电流标定";
            case "_20mACal":
                return "20mA电流标定";
            case "StartPercent":
                return "起点百分比";
            case "altitudeBP":
                return "海拔基点"
            case "BaudRateIndex":
                return "波特率设置"
            //5112
            case "Angle_lock":
                return "角度锁定"
            case "Sensitivity":
                return "敏感度"
            case "Work_mode":
                return "休眠模式"
            case "Roll_comp_angle":
                return "横滚补偿角"
            case "Pitch_comp_angle":
                return "俯仰补偿角"
            case "Maximal_velocity":
                return "最大流速"
            case "Velocity_Adj":
                return "流速偏量"
            case "Frequency_div_level":
                return "分频等级"
            case "Subband_height":
                return "子带高度"
            case "Subband_width":
                return "子带宽度"
            case "Subband_amp_coef":
                return "子带幅度系数"
            case "Window_func_type":
                return "窗函数类型"
            case "Fund_frequency":
                return "基频"
            case "ADC_sampling_switch":
                return "ADC数据采样开关"
            case "Reference_height":
                return "基准高度"
            case "Echo_display_mode":
                return "回波显示方式"
            case "Echo_display_height":
                return "回波显示高度"
            case "Filtering_alert":
                return "滤波警戒"
            case "Filtering_threshold":
                return "滤波阈值"
            case "Filtering_size":
                return "滤波大小"
            case "ProbeType":
                return "探头类型"
            case "SignalThreshold":
                return "信号阈值"
            case "EnvelopeSwitch":
                return "包络线开关"
            case "AutoGainSwitch":
                return "自动增益开关"
            case "Dielectric":
                return "介电常数"
            case "AutoGainRank":
                return "自动增益等级"
            case "LevelSpeed":
                return "物位速度"
            

            case "LowNearBlank":
                return "低位盲区"
            case "InterfaceLowAdjValue":
                return "界位低位调整"
            case "InterfaceHighAdjValue":
                return "界位高位调整"
            case "InterfaceLowAdjPer":
                return "界位低位调整"
            case "InterfaceHighAdjPer":
                return "界位高位调整"
            case "InterfaceHighNearBlank":
                return "界位高位盲区"
            case "InterfaceLowNearBlank":
                return "界位低位盲区"
            case "RefractiveIndex":
                return "折射率设置"
            case "RefractiveValue":
                return "折射率数值"
            case "InterfaceDistAdj":
                return "界位距离偏量"
            case "OutputSource":
                return "输出源"
            case "GainControl":
                return "增益控制"
            case "CableLength":
                return "缆长设定"
            case "FirstEchoIndex":
                return "选择首波"
            case "JumpDistance":
                return "跳变距离"
            case "JumpSpeed":
                return "跳变速度"
            case "WaitTime":
                return "等待时间"
            case "JumpWay":
                return "跳变方式"
            case "OverflowAlarmDelay":
                return "溢出报警延时"
            case "OverflowAlarm":
                return "溢出报警使能"
            default:
                return str;
            }},

            setFull(){
                this.$refs.lycrud.setFull()
            },
            //自定义操作列按钮方法
            handleClick(row,flag){
                console.log("test2222")
                if(flag=='disable'){
                    UsersUsersdisableEdit({id:row.id}).then(res=>{
                        if(res.code == 2000) {
                            vm.$message.success(res.msg)
                            vm.$refs.lycrud.handleRefresh()//刷新表格数据
                        } else {
                            vm.$message.warning(res.msg)
                        }
                    })
                }
            },
        },
    }
</script>

<style scoped>

</style>